var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListTemplate',{attrs:{"fields":_vm.fields,"api-url":_vm.apiURL,"title":"Rules"}})}
var staticRenderFns = []

export { render, staticRenderFns }